import Icon from "@ant-design/icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function LayoutColumnsOutlined(props) {
  return /*#__PURE__*/_jsxs(Icon, {
    ...props,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2px"
      },
      d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }), /*#__PURE__*/_jsx("path", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2px"
      },
      d: "M12 4l0 16"
    })]
  });
}